import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Homepage } from './pages/Homepage/Homepage';
import { UIKit } from './pages/UIKit/UIKit';
import './styles/reset.css';
import './styles/common.css';
import './styles/main.scss';
import Products from './pages/Products';
import Resources from './pages/Resources';
import MainLayout from './Layout/main';
import AboutProducts from 'pages/AboutProduct';
import RelatedProduct from 'pages/RelatedProduct';
import CropNutritionPrograms from 'pages/CropNutritionPrograms';
import TrialResults from 'pages/TrialResults';
import DetailedOfCropNutrition from 'pages/DetailedOfCropNutrition';

const router = createBrowserRouter([
    { path: '/ui-kit', element: <UIKit /> },
    {
        path: '/',
        element: <MainLayout />,
        children: [
            { index: true, element: <Homepage /> },
            { path: '/products', element: <Products /> },
            { path: '/about-product', element: <AboutProducts /> },
            { path: '/related-product', element: <RelatedProduct /> },
            { path: '/resources', element: <Resources /> },
            { path: '/crop-nutrition-programs', element: <CropNutritionPrograms /> },
            { path: '/trial-results', element: <TrialResults /> },
            { path: '/detail-crop-nutrition-programs', element: <DetailedOfCropNutrition /> },
            // { path: '*', element: <NoMatch /> },
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);
